import MaximizeIcon from '@atlaskit/icon/core/maximize';
import * as React from 'react';

export function SvgFullScreen2() {
  return <MaximizeIcon label="" testId="ads-refreshed-icon" />;
}
